<script>

import axios from 'axios';

export default {
  name: "Login",
  data() {
    return{
      email: null,
      password: '',
      errors: [],
      showPwd: false,
    }
  },
  components:{
  },
  methods: {
    async submitForm() {
      this.errors = []

      if (!this.email) {
        this.errors.push('Email required.');
      } else if (!this.validEmail(this.email.trim())) {
        this.errors.push('Valid email required.');
      }

      if(this.password === '') {
        this.errors.push('Field Password is empty!');
      }

      if(!this.errors.length) {

        const formData = {
          email: this.email,
          password: this.password
        }

        axios.defaults.headers.common['Authorization'] = ''
        localStorage.removeItem('jwt')

        await axios
            .post('/api/login', formData)
            .then(response => {
              const token = response.data.jwt
              this.$store.commit('setToken', token)
              axios.defaults.headers.common['Authorization'] = 'Token ' + token

              localStorage.setItem('jwt', token)
            })
            .catch(error => {
              if (error.response) {
                for(const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                }
              } else if(error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })

        await axios
            .get('/api/user', { params: { token: localStorage.getItem('jwt') } })
            .then(response => {

              if (response.data.firstName.length < 3 || response.data.lastName.length < 3 || response.data.dateOfBirth.length < 3 ||
                response.data.address.length < 3 || response.data.phoneNumber.length < 3) {
                localStorage.setItem('completeForm', 'true')
              } else {
                localStorage.setItem('completeForm', 'false')
              }

              this.$store.commit('setUser', {'id': response.data.ID, 'firstName': response.data.firstName,
                'lastname': response.data.lastName, 'email': response.data.email});

              localStorage.setItem('email', response.data.email);
              localStorage.setItem('id', response.data.ID);
              localStorage.setItem('firstName', response.data.firstName);
              localStorage.setItem('lastname', response.data.lastName);
              localStorage.setItem('sID', response.data.status);
              localStorage.setItem('profile', response.data.profileIMG);
              localStorage.setItem('isRec', response.data.isRecruiter);
              localStorage.setItem('sAccss', response.data.specialAccessDepartment);

              this.$router.push('/')
            })
            .catch(error => {
              if (error.response) {
                for(const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                }
              } else if(error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.trim());
    },
    togglePassword() {
      this.showPwd = !this.showPwd;
    }
  }
}
</script>

<!-- Mejoras clave: diseño responsivo, claridad visual, mejor UX -->
<template>
  <div class="auth-page-wrapper d-flex justify-content-center align-items-center min-vh-100 position-relative">
    <div class="bg-overlay bgcrm-overlay position-absolute top-0 start-0 w-100 h-100"></div>

    <!-- Fondo global -->
    <div class="background-image position-absolute top-0 start-0 w-100 h-100" style="background-image: url('http://dmbgroup.online/wp-content/uploads/2025/07/DMG_GO-389-scaled.jpg'); background-size: cover; background-position: center; opacity: 0.2; z-index: 0;"></div>

    <div class="card shadow-lg rounded-4 overflow-hidden w-100" style="max-width: 920px; z-index: 10;">
      <div class="row g-0">

        <!-- LADO IZQUIERDO (IMAGEN + FRASE) -->
        <div class="col-md-6 d-none d-md-block bg-dark position-relative">
          <div class="h-100 p-4 d-flex flex-column justify-content-between text-white position-relative" style="background-image: linear-gradient(to bottom, rgba(17, 70, 35, 0.6), rgba(0,0,0,0.6)), url('https://dmbgroup.online/wp-content/uploads/2024/09/DMB_M_24-68-scaled.jpg'); background-size: cover; background-position: center;">
            <img src="@/assets/images/logo-light.png" alt="Logo" height="100" class="mb-4 mx-auto d-block">
            <div class="text-center px-3">
              <blockquote class="blockquote">
                <p class="fs-5 fst-italic">“Learn as if you will live forever, live like you will die tomorrow.”</p>
                <footer class="blockquote-footer text-white">Mahatma Gandhi</footer>
              </blockquote>
            </div>
            <div class="text-center small text-white-50">DMB Insurance Agency</div>
          </div>
        </div>

        <!-- LADO DERECHO (FORMULARIO) -->
        <div class="col-md-6 bg-white p-5">
          <div class="mb-4">
            <img src="@/assets/images/logo-circle-white.png" alt="Logo" height="100" class="mb-3 d-md-none mx-auto">
            <h3 class="text-success fw-bold mb-1">Welcome Back!</h3>
            <p class="text-muted">Sign in to continue to CRM</p>
          </div>

          <form @submit.prevent="submitForm">

            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input v-model="email" type="email" class="form-control" id="email" placeholder="Enter your email">
            </div>

            <div class="mb-3">
              <label for="password-input" class="form-label">Password</label>
              <div class="input-group">
                <input v-model="password" :type="showPwd ? 'text' : 'password'" class="form-control" id="password-input" placeholder="Enter your password">
                <button type="button" class="btn btn-outline-secondary" @click="togglePassword">
                  <i :class="showPwd ? 'ri-eye-off-fill' : 'ri-eye-fill'"></i>
                </button>
              </div>
              <div class="text-end mt-1">
                <router-link to="/reset" class="text-decoration-none small">Forgot password?</router-link>
              </div>
            </div>

            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" id="remember">
              <label class="form-check-label" for="remember">Remember me</label>
            </div>

            <div v-if="errors.length" class="alert alert-danger py-2">
              <ul class="mb-0 ps-3">
                <li v-for="error in errors" :key="error">{{ error }}</li>
              </ul>
            </div>

            <button type="submit" class="btn btn-success w-100">Sign In</button>

            <div class="text-center mt-3">
              <router-link to="/reset" class="text-primary text-decoration-underline small">Reset Password</router-link>
            </div>

            <div class="mt-4 text-center">
              <h6 class="mb-3 text-muted">Follow Us</h6>
              <a href="https://www.facebook.com/DMBAGENCY" target="_blank" class="btn btn-sm btn-primary me-2">
                <i class="ri-facebook-fill"></i>
              </a>
              <a href="https://www.instagram.com/dmbinsuranceagency" target="_blank" class="btn btn-sm btn-danger">
                <i class="ri-instagram-fill"></i>
              </a>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.auth-page-wrapper {
  background: linear-gradient(to bottom right, #75d26e, #ffffff);
  position: relative;
}
.bgcrm-overlay {
  background: rgba(0,0,0,0.3);
  z-index: 1;
}
</style>
